import { postForm } from '@/shared/api/client';
import { submitForm } from '@/shared/api/submit';
import { getListRows } from '@/shared/lib/pagination';
import type { SelectOption } from '@/shared/ui/selectTypes';

export interface BillingLogListParams {
  page: number;
  sort: string;
  user_id: string;
  object_id: string;
  type_id: string;
  id: string;
  wallet_id: string;
  amount: string;
  operator_id: string;
  operation_type: string;
  create_time_from: number | '';
  create_time_to: number | '';
}

export function fetchBillingLogList(params: BillingLogListParams) {
  return postForm<Record<string, unknown>>('/billing/billing-log/index/', { ...params });
}

export async function fetchBillingLogTypes(): Promise<SelectOption[]> {
  const res = await postForm<Record<string, unknown>>('/billing/billing-log/get-types/');
  return getListRows<{ type_id: number | string; description?: string }>(res, ['types']).map((type) => ({
    value: String(type.type_id),
    label: String(type.description ?? type.type_id),
  }));
}

export function fetchBillingPaymentList(page: number) {
  return postForm<Record<string, unknown>>('/billing/billing-payment/index/', {
    page,
    sort: '-create_time',
  });
}

export function fetchWithdrawalList(page: number) {
  return postForm<Record<string, unknown>>('/billing/billing-withdrawal/index/', { page });
}

export type WithdrawalAction = 'assign-manager' | 'approve' | 'cancel';

export function runWithdrawalAction(action: WithdrawalAction, withdrawalId: number | string) {
  return submitForm(`/billing/billing-withdrawal/${action}/`, { withdrawal_id: String(withdrawalId) });
}
